import { mapGetters } from 'vuex'

export const noticePopup = {
  name: 'noticePopup',
  computed: {
    ...mapGetters(['getStoreIdx']),
    noticePopupTitle () {
      // 특정 idx에 해당하는 경우 해당 idx의 내용으로 치환
      const targetIdx = this.getStoreIdx

      return this.getSpecialNoticeTitle(targetIdx)
    }
  },
  methods: {
    getSpecialNoticeTitle (idx) {
      // VUE_APP_STEP 환경변수를 기준으로 환경별 titleMap 분리
      const step = process.env.VUE_APP_STEP || 'dev'
      const titleMap = this.getTitleMapByStep(step)
      console.debug('getSpecialNoticeTitle---', titleMap)
      // titleMap에 해당 idx가 있으면 반환, 없으면 기본 title 반환
      return titleMap[idx] || this.$tc('notice_popup_title')
    },
    getTitleMapByStep (step) {
      // 환경별 titleMap 정의
      const titleMapByStep = {
        // 개발 환경 (dev)
        dev: {
          51530: '개발 환경 특별 공지사항 제목'
        },
        // 스테이징 환경 (staging)
        sta: {
          7: '스테이징 환경 특별 공지사항 제목',
          51975: '스테이징 환경 특별 공지사항 제목',
          51618: '으아아아아아아악'
        },
        // 프로덕션 환경 (pro)
        pro: {
          12936: '리만 오프라인 마켓플레이스 이용 안내',
          505: '운영 환경 특별 공지사항 제목'
        }
      }

      // 해당 환경의 titleMap 반환, 없으면 빈 객체 반환
      return titleMapByStep[step] || {}
    }
  }
}
